import { Box } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";

// Normaliza o HTML vindo do editor (artigos legados e seções de página customizada)
const richTextSx: SxProps<Theme> = {
  // Estilos para normalização de conteúdo HTML
  '& *': {
    fontFamily: 'Roboto, Arial, sans-serif !important',
    maxWidth: '100%',
  },
  '& p': {
    mb: 2,
    lineHeight: 1.8,
    fontSize: '1.1rem !important',
    color: 'text.primary',
    margin: '0 0 16px 0',
  },
  '& span': {
    fontSize: 'inherit !important',
    lineHeight: 'inherit !important',
  },
  '& div': {
    maxWidth: '100%',
  },
  '& img': {
    maxWidth: '100%',
    height: 'auto',
    borderRadius: 1,
    my: 2,
    display: 'block',
  },
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    mt: 3,
    mb: 2,
    fontWeight: '600 !important',
    color: 'primary.main',
    lineHeight: '1.4 !important',
  },
  '& h1': { fontSize: '2rem !important' },
  '& h2': { fontSize: '1.75rem !important' },
  '& h3': { fontSize: '1.5rem !important' },
  '& h4': { fontSize: '1.25rem !important' },
  '& h5': { fontSize: '1.1rem !important' },
  '& h6': { fontSize: '1rem !important' },
  '& ul, & ol': {
    ml: 3,
    mb: 2,
    pl: 2,
  },
  '& li': {
    mb: 1,
    lineHeight: 1.8,
    fontSize: '1.1rem !important',
  },
  '& strong, & b': {
    fontWeight: '600 !important',
  },
  '& em, & i': {
    fontStyle: 'italic',
  },
  '& a': {
    color: 'primary.main',
    textDecoration: 'underline',
    '&:hover': {
      color: 'primary.dark',
    },
  },
  '& table': {
    width: '100%',
    borderCollapse: 'collapse',
    mb: 2,
    overflow: 'auto',
    display: 'block',
  },
  '& td, & th': {
    border: '1px solid',
    borderColor: 'divider',
    padding: '12px',
    textAlign: 'left',
    fontSize: '1rem !important',
  },
  '& th': {
    backgroundColor: 'grey.100',
    fontWeight: '600 !important',
  },
  '& blockquote': {
    borderLeft: '4px solid',
    borderColor: 'primary.main',
    pl: 2,
    ml: 0,
    my: 2,
    py: 1,
    fontStyle: 'italic',
    backgroundColor: 'grey.50',
  },
  '& pre': {
    backgroundColor: 'grey.100',
    p: 2,
    borderRadius: 1,
    overflow: 'auto',
    mb: 2,
  },
  '& code': {
    fontFamily: 'monospace !important',
    fontSize: '0.9rem !important',
    backgroundColor: 'grey.100',
    px: 0.5,
    borderRadius: 0.5,
  },
  '& hr': {
    my: 3,
    borderColor: 'divider',
  },
};

export function RichTextContent({ html }: { html: string | undefined }) {
  if (!html) return null;

  return <Box sx={richTextSx} dangerouslySetInnerHTML={{ __html: html }} />;
}
